import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import { ValidationHelper } from '../../common/helpers/ValidationHelper';
import FormHelperText from '@material-ui/core/FormHelperText';

export class ImageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div className={css(Styles.outerContainer)}>
        {this.props.data.image &&
          <div className={css(Styles.imageMainContainer)}>
            <img
              src={this.props.data.image}
              className={css(Styles.imageContent)}
            />
          </div>
        }

        {(this.props.data.image2 || this.props.data.image3) &&
          <div className={(this.props.data.image2 && this.props.data.image3) ? css(Styles.innerContainer, Styles.innerContainerVariant) : css(Styles.innerContainer)}>
            {this.props.data.image2 &&
              <div className={css(Styles.imageInnerContainer)}>
                <div className={css(Styles.imageContainer)}>
                  <img
                    src={this.props.data.image2}
                    className={css(Styles.imageContent)}
                  />
                </div>
              </div>
            }
            {this.props.data.image3 &&
              <div className={css(Styles.imageInnerContainer)}>
                <div className={css(Styles.imageContainer)}>
                  <img
                    src={this.props.data.image3}
                    className={css(Styles.imageContent)}
                  />
                </div>
              </div>
            }
          </div>
        }
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //maxWidth: 650,
    marginTop: 30
  },
  imageMainContainer: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageContent: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  innerContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 50,
    alignItems: 'center'
  },
  innerContainerVariant: {
    width: '95%'
  },
  imageInnerContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  imageContainer: {
    width: '90%',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/ImageComponent.js